//Compare slider operations start
document.addEventListener('DOMContentLoaded', () => {
    // Prevent default anchor scroll on page load
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }
    const slider = document.querySelector('.compare-slider');
    if(slider){
        const handle = document.querySelector('.compare-slider-handle');
        const afterImage = document.querySelector('.after');

        let isDragging = false;

        function updateSlider(x) {
            const sliderRect = slider.getBoundingClientRect();
            const offsetX = x - sliderRect.left;

            if (offsetX >= 0 && offsetX <= sliderRect.width) {
            handle.style.left = `${offsetX}px`;
            afterImage.style.clip = `rect(0, ${offsetX}px, ${sliderRect.height}px, 0)`;
            }
        }

        // Mouse support
        handle.addEventListener('mousedown', () => {
            isDragging = true;
            document.body.style.cursor = 'ew-resize';
        });

        document.addEventListener('mouseup', () => {
            isDragging = false;
            document.body.style.cursor = 'default';
        });

        document.addEventListener('mousemove', (e) => {
            if (isDragging) updateSlider(e.clientX);
        });

        // Touch support
        handle.addEventListener('touchstart', () => {
            isDragging = true;
        });

        document.addEventListener('touchend', () => {
            isDragging = false;
        });

        document.addEventListener('touchmove', (e) => {
            if (isDragging && e.touches.length > 0) {
                updateSlider(e.touches[0].clientX);
            }
        });

        const initial = slider.offsetWidth / 4;
        handle.style.left = `${initial}px`;
        afterImage.style.clip = `rect(0, ${initial}px, ${slider.offsetHeight}px, 0)`;
    }
});
//Compare slider operations end

//lenis init
const lenis = new Lenis({
    duration: 1.5,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smooth: true,
    smoothTouch: true,
});
lenis.on('scroll', ScrollTrigger.update);
gsap.ticker.add((time)=>{
    lenis.raf(time * 1000);
});
gsap.ticker.lagSmoothing(0);


  const videos = document.querySelectorAll('video[data-src]');
  const config = {
    rootMargin: '500px 0px',
    threshold: 0.01
  };

  const loadVideo = (video) => {
    const source = document.createElement('source');
    source.src = video.getAttribute('data-src');
    source.type = 'video/mp4';
    video.appendChild(source);
    video.load();
    video.removeAttribute('data-src');
  };

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        loadVideo(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, config);

  videos.forEach(video => {
    observer.observe(video);
  });

jQuery(function($){
    ScrollTrigger.config({ ignoreMobileResize: true });

    if (window.location.hash) {
        const id = window.location.hash;
        const elemToScroll = $(id);
        if (elemToScroll.length > 0) {
            setTimeout(() => {
                doScroll(id, elemToScroll);
            }, 200);
        }
    }


    //get url params
    const params = new URLSearchParams(window.location.search);
    const type = params.get('type');
    if(type){
        formOperations(type);
    }

    //Gsap responsive
    const mm = gsap.matchMedia();

    mm.add("(max-width: 991px)", () => {
        ScrollTrigger.refresh();
        return () => {}
    });
    mm.add("(min-width: 992px)", () => {
        ScrollTrigger.refresh();
        return () => {}
    });

    var btns = $('#siteheader nav ul li a');
    if(btns.length > 0){
        menuOperations(btns);
    }

    //Video operations
    $(document).on('click', '.video-container .control-container .playback', function() {
        var $wrapper = $(this).closest('.video-container');
        var video = $wrapper.find('video')[0];
        var $icon = $(this).find('i');

        if (video.paused) {
            video.play().then(() => {
                $icon.removeClass('icon-play').addClass('icon-stop');
            }).catch(err => {
                console.warn('Autoplay blocked:', err);
            });
        } else {
            video.pause();
            $icon.removeClass('icon-stop').addClass('icon-play');
        }
    });

    $(document).on('click', '.video-container .control-container .sound', function() {
        var $wrapper = $(this).closest('.video-container');
        var video = $wrapper.find('video')[0];
        var $icon = $(this).find('i');

        video.muted = !video.muted;
        if (video.muted) {
            $icon.removeClass('icon-mute').addClass('icon-unmute');
        } else {
            $icon.removeClass('icon-unmute').addClass('icon-mute');
        }
    });

    const headerHeight = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--header-height')
    );

    gsap.set('.animated-region', {xPercent: () => -120});

    const containerAnimation = gsap.to(".animated-region",
    {
        xPercent: () => 0,
        ease: "none",
        scrollTrigger: {
        trigger: ".animated-pin",
        start:() => 'top bottom',
        end:() => '+=200%',
        scrub: true,
        // pin: true,
        //markers: true
        }
    });

    // Extra pin after animation
    ScrollTrigger.create({
        trigger: ".animated-pin",
        start: () => `top-=${headerHeight} top`,
        end: () => `+=140%`, // longer than the animation's end
        pin: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        //markers: true
    });

    // Trigger each region based on container animation progress
    const regions = gsap.utils.toArray(".animated-region .region");

    // Track each region’s visibility within the animated container
    gsap.utils.toArray(".animated-region .region").forEach((region) => {
        ScrollTrigger.create({
            trigger: region,
            containerAnimation: containerAnimation,
            start: () => "left 3%",   // region's left hits center of viewport
            invalidateOnRefresh: true,
            onEnter: () => {
            region.classList.add("active");
            },
            onLeaveBack: () => {
            region.classList.remove("active");
            },
            scrub: false,
            //markers: true
        });
    });

    const showcases = $('.showcase-wrapper');
    if(showcases.length > 0){
        showcaseAnim(headerHeight);
    }

    //Half title height margin top
    var title = $('.animated-image-wrapper .title-col h2');
    var text = $('.animated-image-wrapper .text-col .text');
    if(title.length > 0){
        var text = $('.animated-image-wrapper .text-col .text');
        if(text.length > 0){
            mm.add("(min-width: 991px)", () => {
                responsiveTextMargin(title, text);
                ScrollTrigger.refresh();
                return () => { 
                    resetResponsiveTextMargin(text);
                    ScrollTrigger.refresh();
                };
            });
        }
    }

    //modal ajax operetions
    $('#infoModal').on('show.bs.modal', function(event) {
        var button = $(event.relatedTarget);
        var postId = button.data('post-id');
        var modal = $(this);

        $.ajax({
            url: my_ajax_object.ajaxurl,
            type: 'POST',
            data: {
                action: 'load_post_modal',
                post_id: postId
            },
            success: function(response) {
                if (response.success) {
                    modal.find('.modal-content .populated-content').html(response.data.content);
                } else {
                    modal.find('.modal-content .populated-content').html('<p>' + response.data + '</p>');
                }
            }
        });
    });


    //Stops scroll on menu open
    $('#mainNavigation').on('show.bs.collapse', function () {
        stopScroll();
    });

    //Resumes scroll on menu close
    $('#mainNavigation').on('hide.bs.collapse', function () {
        resumeScroll();
    });

    //On modal open stopScroll
    $('.modal').on('show.bs.modal', function(event) {
        stopScroll();
    });

    //On modal hide resumeScroll
    $('.modal').on('hide.bs.modal', function(event) {
        resumeScroll();
    });

    var slider = $('.slider');
    if(slider.length > 0){
        initSwiperCarousel('.slider', false, 24, false, '', '', 2.1, 2.1, 2.1, '', '');
        ScrollTrigger.refresh();
    }
});

function menuOperations(btns){
    btns.on('click', function(e){
        var url = $(this).attr('href');
        var id = url.split('#')[1];
        id = '#' + id;
        var elemToScroll = $(id);
        if(elemToScroll.length > 0){
            e.preventDefault();
            //check if menu is open
            var navbar = $('.navbar-collapse.show');
            if(navbar.length > 0){
                const bsCollapse = bootstrap.Collapse.getOrCreateInstance(navbar);
                navbar.one('hidden.bs.collapse', function(){
                    doScroll(id, elemToScroll);
                });
                bsCollapse.hide();
            }else{
                doScroll(id, elemToScroll);
            }
        }
    });
}

function doScroll(id, elemToScroll) {
    if(elemToScroll.length > 0){
        var scrollPaddingtop = elemToScroll.css('scroll-padding-top');
        lenis.scrollTo(id, {offset: -parseInt(scrollPaddingtop), immediate: true, duration: 0});
    }
}

function showcaseAnim(headerHeight){
      document.querySelectorAll('.showcase-wrapper').forEach(wrapper => {
        const elems = wrapper.querySelectorAll('.showcase');
        const images = wrapper.querySelectorAll('.showcase-image');

        gsap.to({}, {
            scrollTrigger: {
                trigger: wrapper,
                start: () => `top-=${headerHeight + 20} top`,
                end: () => `+=${elems.length}%`,
                scrub: true,
                pin: true,
                markers: false,
                onUpdate: self => {
                    const progress = self.progress; // 0 to 1
                    const index = Math.floor(progress * elems.length);

                    // Clamp to last valid index
                    const current = Math.min(index, elems.length - 1);

                    elems.forEach((el, i) => {
                        el.classList.toggle('active', i === current);
                    });

                    images.forEach((img, i) => {
                        img.classList.toggle('show', i === current);
                    });
                }
            }
        });
    });
}

//Fixes fancybox scroll issues inside modal
Fancybox.bind("[data-fancybox]", {
  autoFocus: false,
  trapFocus: false,
  placeFocusBack: false,
  dragToClose: false, // optional: avoids gesture-related jumpiness
});

var previousScrollY = 0;
function stopScroll(){
    previousScrollY = window.scrollY;
    $('body').addClass('freeze').css({
        marginTop: -previousScrollY,
    });
    lenis.stop();
}

function resumeScroll(){
    $('body').removeClass('freeze').css({
        marginTop: 0,
    });
    lenis.start();
    window.scrollTo({
        top: previousScrollY,
        left: 0,
        behavior: 'instant'
    });
}

function responsiveTextMargin(title, text){
    var titleHeight = $(title).height();
    if(text.length > 0){
        text.css('margin-top', titleHeight / 2);
        ScrollTrigger.refresh();
    }
}

function resetResponsiveTextMargin(text){
    text.css('margin-top', 0);
    ScrollTrigger.refresh();
}

function initSwiperCarousel(carousel, center, spacing, isLoop, next, prev, slidesMd, slidesLg, slidesXl, pagination, effect){
    var test = new Swiper(carousel, {
        slidesPerView: 1.2,
        grabCursor: true,
        watchSlidesVisibility: true,
        centeredSlides: center,
        spaceBetween: 24,
        loop: isLoop,
        effect: effect,
        coverflowEffect: {
            rotate: 0,
            stretch: 10,
            depth: 160,
            slideShadows: false,
            modifier: 4,
        },
        navigation: {
            nextEl: next,
            prevEl: prev,
        },
        pagination: {
            el: pagination,
            clickable: true,
        },
        breakpoints: {
            768: {
                spaceBetween: 24,
                slidesPerView: slidesMd,
            },
            991: {
                spaceBetween: 24,
                slidesPerView: slidesLg,
            },
            1200: {
                spaceBetween: spacing,
                slidesPerView: slidesXl,
            }
        }
    });
}

function formOperations(type){
    var select = $('.type-select select');
    if(select.length > 0){
        var formattedType = type.replace(/-/g, ' ');

        select.find('option').each(function() {
            if ($(this).text().trim().toLowerCase() === formattedType.toLowerCase()) {
                $(this).prop('selected', true);
                select.trigger('change'); // in case you have listeners
                return false; // stop loop once matched
            }
        });
    }
}